// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"163":"MobileAppPage","383":"SalePage"}[chunkId] || chunkId) + "." + {"163":"4c4189f9","212":"0f4e0bb6","383":"baad11d9"}[chunkId] + ".js";
};